import axios from "axios"

export default class AbstractAxiosService {
	constructor(options = {}) {
		this.groupedRequests = []
		this.accumulatorUrl = ""
		this.accumulatorCancelGroups = []
		this.defaultHeaders = {}
		this.debugAccumulator = false
		Object.assign(this, options)
	}

	makeRequest(method, url, ...args) {
		return this.makeRequestRaw(method, url, ...args)
			.then((response) => this.translateApi(response))
			.catch((err) => this.translateError(err))
	}
	makeRequestRaw(method, url, ...args) {
		let ep = this.endpoint
		//append an api key
		let opts = ["put", "post", "patch"].indexOf(method) >= 0 ? args[1] : args[0]
		if (opts == null) {
			opts = {}
			args.push(opts)
		}
		opts.headers = {...this.defaultHeaders, ...(opts.headers || {})}
		if (this.endpointApiKey) {
			opts.headers["Authorization"] = `ApiKey ${this.endpointApiKey}`
		}
		
		let outUrl = url
		if (opts.path) {
			//replace path with slugs
			outUrl = outUrl.replace(/\:([a-z\-]+)?/g, (match, g1) => opts.path[g1] != null ? opts.path[g1] : "")
		}
		
		if(this.mock) {
			return this.mock.request(method, url, ...args)
		} else if (opts.group && this.accumulatorUrl) {
			return this.groupRequest(opts.group, method, ep + outUrl, ...args)
		} else {
			return axios[method](ep + outUrl, ...args)
		}
	}

	groupRequest(group, method, url, ...args) {
		let buildUrl = url
		let hasBody = ["put", "post", "patch"].indexOf(method) >= 0
		let opts = hasBody ? args[1] : args[0]
		let body = hasBody ? args[0] : null
		
		if (opts.params) {
			buildUrl += "?" + Object.entries(opts.params)
				.filter(([k, v]) => v !== undefined) // don't send a param if it's undefined
				.map(([k, v]) => `${window.encodeURI(k)}=${window.encodeURI(v)}`)
				.join('&')
		}
		const req = {
			group, 
			method,
			url: buildUrl,
			body,
			opts,
			args,
			resolve: null,
			reject: null,
			promise: null,
			state: 0,
		}
		let prom = new Promise((resolve, reject) => {
			req.resolve = resolve
			req.reject = reject
		})
		req.promise = prom
		this.groupedRequests.push(req)

		setTimeout(() => this.executeGroupRequests(), 5)

		return prom
	}

	async executeGroupRequests() {
		let groupRequests = []
		let rndId = Math.random().toString()

		//HACK: this mechanic is currently not flawless because the original group is not always requested
		let firstGroup = null
		for (let req of this.groupedRequests) {
			if (req.groupId != null) continue
			
			firstGroup = firstGroup || req.group
			req.groupId = rndId
			req.groupIdx = groupRequests.length
			groupRequests.push({
				method: req.method.toUpperCase(),
				url: req.url,
				body: req.body,
				headers: req.opts ? req.opts.headers : null
			})
		}

		if (groupRequests.length < 1) {
			//if there is nothing todo, escape
			return
		}

		// help us to debug whats going over the accumulator
		if (this.debugAccumulator) {
			console.debug("Accumulator Group(%s)", firstGroup)
			groupRequests.forEach(v => console.debug("  %s: %s", v.method, v.url))
		}

		let result = null
		try {
			let accumulatorUrl = this.accumulatorCancelGroups.includes(firstGroup)
				? `${this.accumulatorUrl}?cancelOnFail=true`
				: this.accumulatorUrl
				
			result = await axios.post(accumulatorUrl, { requests: groupRequests})
		} catch(err) {
			result = err
		}
		let affectedRequets = this.groupedRequests.filter(v => v.groupId == rndId)
		for (let req of affectedRequets) {
			if (result.data != null && result.data.responses[req.groupIdx]) {
				let reqData = result.data.responses[req.groupIdx]
				if (reqData.statusCode >= 200 && reqData.statusCode <= 301) {
					req.resolve({
						statusCode: reqData.statusCode,
						data: reqData.content,
					})
				} else {
					req.reject({
						response: {
							statusCode: reqData.statusCode,
							data: reqData.content,
						}
					})
				}
			} else {
				req.reject({
					response: {
						statusCode: 500,
						data: {
							message: "Accumulator Error"
						}
					}
				})
			}
		}

	}

	translateApi(response) {
		// {
		// 	data: {},
		// 	status: 200,
		// 	statusText: 'OK',
		// 	headers: {},
		// 	config: {},
		// 	request: {}
		// }

		// detect dataformat
		if (response.data == null && response.statusCode == 204) {
			return Promise.resolve(true)
		} else if (response.data.error) {
			return Promise.reject({ status: response.statusCode, code: response.data.errorCode, message: response.data.errorMessage })
		} else if (response.data.errors && !response.data.success) {
			// TODO: currently poinz register returns an empty errors array with success = true
			return Promise.reject({ status: response.statusCode, code: response.data.errorCode, message: "validation", errors: response.data.errors })
		} else if (response.data.status != false) {
			//TODO: the api is inconsistent in the response format
			return Promise.resolve(response.data.response || response.data)
		} else {
			return Promise.reject({ code: response.statusCode })
		}
	}
	translateError(err) {
		// Polyfill the response not to be null
		err.response = err.response || "Network Error"
		return Promise.reject(err)
	}

}
